<template>
  <li class="list_once">
    <p class="p">如何使用模板发起签约</p>
    <p class="text">1.在首页中点击“授权给我的模板”进入我的模板页面；</p>
    <img class="img" src="/images/home/sign_img5.png" alt="">
    <p class="text">2.点击立即发起（若无模板请先进入企业控制台进行创建，创建完成后授权给需要使用的成员）；</p>
    <img class="img" src="/images/home/sign_img6.png" alt="">
  </li>
</template>
<script>
  export default {
    data () {
      // 这里存放数据
      return {}
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .list_once {
    font-size: 14px;
    padding: 10px;
    .p {
      font-size: 16px;
      font-weight: bold;
    }
    .text {
      margin: 10px 0;
    }
    .img {
      max-width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// pages/dingtalkUse/helpCenterCom/2_tempSign.vue